var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 15C31 20.1172 28.5981 24.6729 24.8602 27.6016C27.2047 29.1191 29.9994 30 33 30C41.2843 30 48 23.2842 48 15C48 6.71582 41.2843 0 33 0C29.9994 0 27.2047 0.880859 24.8602 2.39844C28.5981 5.32715 31 9.88281 31 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C18.0006 30 20.7953 29.1191 23.1398 27.6016C19.4019 24.6729 17 20.1172 17 15C17 9.88281 19.4019 5.32715 23.1398 2.39844C20.7953 0.880859 18.0006 0 15 0C6.7157 0 0 6.71582 0 15C0 23.2842 6.7157 30 15 30Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15C18 19.9072 20.3567 24.2646 24 27.001C27.6433 24.2646 30 19.9072 30 15C30 10.0928 27.6433 5.73535 24 2.99902C20.3567 5.73535 18 10.0928 18 15Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard2);
export default __webpack_public_path__ + "static/media/MasterCard2.ff967bfbd95fa7a7a903b910d29d83f4.svg";
export { ForwardRef as ReactComponent };